export default __webpack_public_path__ + "static/media/morphology.56b4f4cd.svg";